import {
  FlightGuestProps,
  FlightTripType,
} from '@components/views/flight/types';
import { initialGuestInfo } from '@components/views/flight/constants';
import { AirportSearchViewModel } from '@api/index';
import { SearchBarDateType } from '@utils/dateUtil';

export interface IFlightSearchBarState {
  startDate?: SearchBarDateType;
  endDate?: SearchBarDateType;
  guestInfo?: FlightGuestProps;
  arrivalAirport?: AirportSearchViewModel | null;
  departureAirport?: AirportSearchViewModel | null;
  flightTripType?: FlightTripType;
  isOneWay?: boolean;
  isDirectFlight?: boolean;
  isValidFlightSearchBar?: boolean;
  isSubmit?: boolean;
  cabinClass: 'All' | 'Business' | 'Economy';
}

export const initialState = {
  startDate: new Date(),
  guestInfo: initialGuestInfo,
  isOneWay: false,
  isDirectFlight: false,
  isValidFlightSearchBar: false,
  isSubmit: false,
  cabinClass: 'All' as IFlightSearchBarState['cabinClass'],
};
